import type { APIBookingDraftService, APIBookingDraftServiceWarning } from '@/scopes/checkout/infrastructure/api/types';
import type { CheckoutServiceBanner } from '../../../domain/types';

export interface ServiceBannersMapper {
  map: (service: APIBookingDraftService) => CheckoutServiceBanner[];
}

export const createServiceBannersMapper = () => {
  function map({ warnings }: APIBookingDraftService) {
    return warnings?.map(mapWarningToBanner) ?? [];
  }

  function mapWarningToBanner({ title, message, type }: APIBookingDraftServiceWarning) {
    return {
      ...(title && { title }),
      ...(message && { text: message }),
      type: type?.toLowerCase() || 'info',
    };
  }

  return { map };
};
